import { useAppDispatch } from '../../../../ReduxToolkit/Hooks';
import { CartQuantityButtonProp, CartType } from '../../../../Type/Application/Ecommerce/Product';
import { Input } from 'reactstrap';
import { decrementData, incrementData, setTotal} from '../../../../ReduxToolkit/Reducers/CartSlice';
import { toast } from 'react-toastify';

const CartQuantityButton = ({ item }: CartQuantityButtonProp) => {
  const dispatch = useAppDispatch();

  const incrementQty = (product: CartType, quantity: number) =>
    dispatch(incrementData({ item: product, quantity: quantity }));

  const decrementQuantity = (id: number) =>
    dispatch(decrementData(id));

  const handleInputChange = ( e: React.ChangeEvent<HTMLInputElement>, id: number, stock: number) => {
    const raw = e.target.value;

    // Permettre à l'utilisateur de taper "." ou "0."
    if (raw === '' || raw === '.' || raw === '0.') {
      dispatch(setTotal({ id, total: raw }));
      return;
    }

    const value = Number(raw);

    // Si ce n’est pas un nombre valide → ignorer
    if (isNaN(value)) return;

    // Empêcher valeurs négatives
    if (value < 0) return;

    // Vérifier stock
    if (value > stock) {
      toast.info('Quantité supérieure au stock disponible, veuillez approvisionner le produit');
      return;
    }

    dispatch(setTotal({ id, total: value }));
  };

  return (
    <td>
      <div className="touchspin-wrapper">

        <Input
          className="input-touchspin spin-outline-primary"
          type="number"
          value={item.total}
          onChange={(e) => handleInputChange(e, item.id, item.quantite_stock)}
        />
      </div>
    </td>
  );
};

export default CartQuantityButton;
